module.exports = __webpack_public_path__ + "44c52445fac7495dd6c46239e879eab4.svg";